import { IConfig } from './IConfig'

export const configStaging: IConfig = {
  api: {
    url: 'https://fb-ig-booking-app.staging.blvd.co'
  }
}
